import React from 'react'
import _Highlighter from "react-highlight-words"

const reg = (str) => str.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&')

const Highlighter = ({ searchWords, ...rest }) => {
  const regSearchWords = searchWords.map(word => reg(word))
  return <_Highlighter searchWords={regSearchWords} {...rest} />
}

export default Highlighter


// WEBPACK FOOTER //
// ./src/app/components/normal/HighLighter.js